import React from "react";

import * as S from "./styles";

export const PlantBased: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Wrapper>
          <S.Title>Universo</S.Title>
          <S.Title>plant-based</S.Title>
          <S.Text>
            <p>
              Antes de a pandemia se tornar um divisor de águas, impactando
              vidas e economias, já estávamos passando por diferentes
              transformações no mercado de consumo, com grandes marcas
              reavaliando e se reajustando aos desejos e necessidades do mundo
              atual, principalmente em relação ao meio ambiente.
            </p>
            <p>
              O universo plant-based é um dos que vêm ganhando cada vez mais
              espaço entre os consumidores que buscam uma vida mais saudável,
              com menos impacto ambiental e aproximação com a natureza.
            </p>
          </S.Text>
          <S.Text>
            <p>
              Atualmente, é possível observar o crescimento desse consumo no
              mercado gastronômico, com carnes sendo produzidas à base de
              vegetais, e também no mercado vegano de beleza, em que novas
              marcas traçam estratégias de medição do impacto de suas produções.
              Mas e no mercado da moda? E, mais especificamente, no de tecidos?
            </p>
          </S.Text>
        </S.Wrapper>
      </S.Content>
    </S.Container>
  );
};
